module.exports = __webpack_public_path__ + "static/media/38-7.1e2a5177.mp3";